import { Button } from '@nexelem/components';
import { getTranslation } from '@nexelem/utils';
import { CLEAR_EDITOR_COMMAND, LexicalEditor } from 'lexical';
import { useCallback, useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { StaticModal } from '@nexelem/modals';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateLeft } from '@fortawesome/pro-light-svg-icons';

type ShowClearDialogProps = {
  editor: LexicalEditor;
  onClose: () => void;
};
export const ShowClearDialog = ({ editor, onClose }: ShowClearDialogProps) => {
  const { t: translation } = useTranslation();
  const t = useMemo(() => getTranslation(translation, 'components.richTextEditor.clearModal'), [translation]);
  const onClickConfirm = useCallback(() => {
    editor.dispatchCommand(CLEAR_EDITOR_COMMAND, undefined);
    editor.focus();
    onClose();
  }, [editor, onClose]);

  const onClickCancel = useCallback(() => {
    editor.focus();
    onClose();
  }, [editor, onClose]);

  return (
    <>
      <StaticModal.Header withCloseButton>{t('title')}</StaticModal.Header>
      <StaticModal.Content className="flex flex-col gap-6">
        <p className="text-s18">
          <Trans components={{ strong: <strong /> }}>{t('paragraph1')}</Trans>
        </p>
        <span className="[&_svg]:text-6 text-s18 [&_svg]:align-middle">
          <Trans components={{ Icon: <FontAwesomeIcon icon={faRotateLeft} /> }}>{t('paragraph2')}</Trans>
        </span>
      </StaticModal.Content>
      <StaticModal.Footer>
        <Button variant="outlined" onClick={onClickConfirm}>
          {t('clear')}
        </Button>
        <Button variant="contained" onClick={onClickCancel}>
          {t('cancel')}
        </Button>
      </StaticModal.Footer>
    </>
  );
};
